'use client';
import { ToastProvider, ToastViewport } from '@//components/Toast';
import { useToast } from '@//providers/ToastProvider';
import ToastItem from './ToastItem';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  return (
    <ToastProvider>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onRemove={removeToast} />
      ))}
      <ToastViewport />
    </ToastProvider>
  );
};

export default ToastContainer;
